import React, { useEffect, useState } from 'react'
import { PaymentScaleModal } from './PaymentScaleModal'
import { Card } from 'react-bootstrap'
import { BsEye } from 'react-icons/bs'
import { getPaymentScaleUsers } from '../../../../Api/Admin/Admin'

export const PaymentScale = () => {
    const [show, setShow] = useState(false)
    const [paymentScaleInfo, setPaymentScaleInfo] = useState('')
    const getPaymentScaleinfo = async () => {
        let paymentScale = await getPaymentScaleUsers();
        setPaymentScaleInfo(paymentScale ?? '')
    }

    useEffect(() => {
        getPaymentScaleinfo()
    }, [])

    if (paymentScaleInfo === '') return null

    return (
        <Card className='mb-2'>
            <Card.Body>
                <div onClick={() => setShow(true)} className='d-flex align-items-center gap-2 text-primary text-sm' role='button'>
                    <BsEye />
                    Ver explicación escala de pagos
                </div>
                <PaymentScaleModal show={show} onHide={() => setShow(false)} paymentScaleInfo={paymentScaleInfo} />
            </Card.Body>
        </Card>

    )
}
